import styled from "styled-components";

import colors from "../../assets/css/colors";

//Interface
import { TextContainerProps } from "./interfaces";

export const Container = styled.div`
    position: absolute;
    z-index: 99999;
`;

export const ArrowUpContainer = styled.div`
    display: flex;
    justify-content: flex-start;
    
`;

export const ArrowUp = styled.div`
    width: 0; 
    height: 0;
    margin-left: 4px;
    border-left: 8px solid transparent;
    border-right: 8px solid transparent;
    
    border-bottom: 8px solid ${colors.primary};

    /* @media (max-width: 1200px){
        margin-left: 67px;
    } */
`;

export const TextContainer = styled.div`
    width: 190px;
    font-family: "Circular Std Book";
    background-color: ${colors.primary};
    color: ${colors.white};
    margin-top: -1px;
    margin-left: ${(p: TextContainerProps) => p.margin !== "-undefinedpx" ? p.margin : "-160px"};
    padding: 10px;
    border-radius: 10px;
    
    /* @media (max-width: 1375px){
        margin-left: -10%;
    }

    @media (max-width: 1200px){
        margin-left: 0%;
    } */
`;